module.exports = __webpack_public_path__ + "assets/5896a5131578a8f473fcdf0bc0a99a25.png";